/**
 * Reglas de UI/negocio para anulación de documentos de venta (factura / NC).
 * Alineadas con VentasDocumentoAnulacionRules en eOne.API.
 */

export function tieneCae(caeNro?: string | null): boolean {
  return Boolean(caeNro && String(caeNro).trim());
}

export function esAnuladoPorAsentado(asentado?: string | null): boolean {
  return String(asentado ?? '').trim().toUpperCase() === 'A';
}

export function esAnuladoPorNombre(nombre?: string | null): boolean {
  return String(nombre ?? '').trim().toUpperCase() === 'ANULADO';
}

export function esDocumentoVentaAnulado(
  asentado?: string | null,
  nombre?: string | null,
  considerarNombre = false
): boolean {
  return esAnuladoPorAsentado(asentado) || (considerarNombre && esAnuladoPorNombre(nombre));
}

export function puedeMostrarAnularFacturaVenta(
  caeNro?: string | null,
  asentado?: string | null
): boolean {
  return !tieneCae(caeNro) && !esAnuladoPorAsentado(asentado);
}

export function puedeMostrarAnularNotaCreditoVenta(
  caeNro?: string | null,
  asentado?: string | null,
  nombre?: string | null
): boolean {
  return !tieneCae(caeNro) && !esDocumentoVentaAnulado(asentado, nombre, true);
}
